<div [formGroup]="form()">
  <div class="field-row">
    <div class="field">
      <label class="field-label" for="fullName">Full Name<span class="required">*</span></label>
      <input pInputText id="fullName" class="w-full" [class.ng-invalid]="isInvalid('fullName')"
        [class.ng-dirty]="isInvalid('fullName')" type="text" formControlName="fullName" placeholder="Enter your name" />
      @if (errorFor('fullName', { required: 'Full name is required.', pattern: 'Enter a valid name (letters only).' });
      as msg) {<span class="error-text">{{ msg }}</span>}
    </div>
    <div class="field">
      <label class="field-label" for="phone">Phone Number</label>
      <input pInputText id="phone" class="w-full" [class.ng-invalid]="isInvalid('phone')"
        [class.ng-dirty]="isInvalid('phone')" type="tel" formControlName="phone" placeholder="Optional" />
      @if (errorFor('phone', { pattern: 'Enter a valid phone number.' }); as msg) {
      <span class="error-text">{{ msg }}</span>
      }
    </div>
    <div class="field email-width">
      <label class="field-label" for="email">Email Address<span class="required">*</span></label>
      <input pInputText id="email" class="w-full" [class.ng-invalid]="isInvalid('email')"
        [class.ng-dirty]="isInvalid('email')" type="email" formControlName="email"
        placeholder="Enter your email address" />
      @if (errorFor('email', { required: 'Email address is required.', email: 'Enter a valid email address.' }); as msg)
      {
      <span class="error-text">{{ msg }}</span>
      }
    </div>
  </div>

  <!-- <div class="field mobile-top">
    <label class="field-label">Preferred Contact Method</label>
    <div class="radio-group">
      @for (option of preferredContactOptions(); track option.value) {
      <div class="radio-option">
        <p-radioButton [inputId]="'contact-' + option.value" name="preferredContact" [value]="option.value"
          formControlName="preferredContact" />
        <label [for]="'contact-' + option.value">{{ option.label }}</label>
      </div>
      }
    </div>
  </div> -->
  <div class="field-row zip-row">
    <div class="field zip-field mobile-top marB-zero">
      <label class="field-label" for="zipCode">ZIP Code<span class="required">*</span></label>
      <p-autocomplete inputId="zipCode" type="tel" styleClass="w-full" [inputStyleClass]="'w-full'"
        [class.ng-invalid]="isInvalid('zipCode')" [class.ng-dirty]="isInvalid('zipCode')" [(ngModel)]="zipQuery"
        [ngModelOptions]="{ standalone: true }" [suggestions]="zipSuggestions()" optionLabel="description" [delay]="400"
        [showEmptyMessage]="true" emptyMessage="No matching addresses found." placeholder="90001"
        (completeMethod)="searchZip($event)" (onSelect)="onZipSelect($event)" (ngModelChange)="onZipQueryChange($event)"
        (input)="onZipRawInput($event)" (onBlur)="onZipBlur()">
        <ng-template let-item pTemplate="item">
          <div class="address-suggestion">
            <span class="address-suggestion-main">{{ item.mainText }}</span>
            @if (item.secondaryText || item.zipCode) {
            <span class="address-suggestion-secondary">{{ item.secondaryText }}{{ item.zipCode ? ' ' + item.zipCode :
              '' }}</span>
            }
          </div>
        </ng-template>
      </p-autocomplete>
      @if (isSearchingZip()) {
      <span class="hint-text"><i class="pi pi-spin pi-spinner"></i> Searching addresses…</span>
      } @else if (isLookingUpZip()) {
      <span class="hint-text">
        <i class="pi pi-spin pi-spinner"></i> Looking up city/state…
      </span>
      } @else if (zipLookupError()) {
      <span class="hint-text">{{ zipLookupError() }}</span>
      } @else {
      <span class="hint-text">Select your ZIP, then enter your street address below.</span>
      }
      @if (errorFor('zipCode', { required: 'ZIP code is required.', pattern: 'Enter a valid 5-digit ZIP code.' }); as
      msg) {
      <span class="error-text">{{ msg }}</span>
      }
    </div>

    <button type="button" class="current-location-btn" (click)="useCurrentLocation()" [disabled]="isLocating()">
      @if (isLocating()) {
      <i class="pi pi-spin pi-spinner"></i>
      } @else {
      <img src="assets/images/direction.svg" alt="location" />
      }
      Current Location
    </button>

     <div class="field mobile-top">
      <label class="field-label" for="streetAddress">Street Address<span class="required">*</span></label>
      <p-autocomplete inputId="streetAddress" styleClass="w-full" [inputStyleClass]="'w-full' "
        [class.ng-invalid]="isInvalid('streetAddress')" [class.ng-dirty]="isInvalid('streetAddress')"
        [(ngModel)]="addressQuery" [ngModelOptions]="{ standalone: true }" [suggestions]="addressSuggestions()"
        optionLabel="description" [delay]="400" [showEmptyMessage]="true" [disabled]="!isStreetAddressEnabled()"
        emptyMessage="No matching addresses found."
        [placeholder]="isStreetAddressEnabled() ? 'Start typing your street address…' : 'Enter a ZIP code first'"
        (completeMethod)="searchAddress($event)" (onSelect)="onAddressSelect($event)" (onBlur)="onAddressBlur()">
        <ng-template let-item pTemplate="item">
          <div class="address-suggestion">
            <span class="address-suggestion-main">{{ item.mainText }}</span>
            @if (item.secondaryText || item.zipCode) {
            <span class="address-suggestion-secondary">{{ item.secondaryText }}{{ item.zipCode ? ' ' + item.zipCode :
              '' }}</span>
            }
          </div>
        </ng-template>
      </p-autocomplete>
      @if (isResolvingAddress()) {
      <span class="hint-text"><i class="pi pi-spin pi-spinner"></i> Loading address details…</span>
      } @else if (isSearchingAddress()) {
      <span class="hint-text"><i class="pi pi-spin pi-spinner"></i> Searching addresses…</span>
      } @else if (addressLookupError(); as msg) {
      <span class="error-text">{{ msg }}</span>
      } @else if (errorFor('streetAddress', { required: 'Street address is required.' }); as msg) {
      <span class="error-text">{{ msg }}</span>
      } @else if (isStreetAddressEnabled()) {
      <span class="hint-text">Select your address from the suggestions.</span>
      }
    </div>
  </div>
  <div class="field zip-row">
    @if (locationError(); as msg) {
    <span class="error-text location-error">{{ msg }}</span>
    } @else if (zipMismatchError(); as msg) {
    <span class="error-text location-error">{{ msg }}</span>
    }
  </div>

 
    <!-- <div class="field-row"> <div class="field mobile-top">
      <label class="field-label" for="unit">Apartment/Unit</label>
      <input pInputText id="unit" class="w-full" [class.ng-invalid]="isInvalid('unit')"
        [class.ng-dirty]="isInvalid('unit')" type="text" formControlName="unit" placeholder="Apartment/Unit" />
      @if (errorFor('unit', { pattern: 'Enter a valid apartment/unit.' }); as msg) {
      <span class="error-text">{{ msg }}</span>
      }
    </div> </div>-->
   
  

  <div class="field-row">
    <div class="field mobile-top">
      <label class="field-label" for="city">City<span class="required">*</span></label>
      <input pInputText id="city" class="w-full" [class.ng-invalid]="isInvalid('city')"
        [class.ng-dirty]="isInvalid('city')" type="text" formControlName="city" placeholder="City" />
      @if (errorFor('city', { required: 'City is required.', pattern: 'Enter a valid city name.' }); as msg) {
      <span class="error-text">{{ msg }}</span>
      }
    </div>
    <div class="field mobile-top">
      <label class="field-label" for="county">County<span class="required">*</span></label>
      <p-select inputId="county" styleClass="w-full" [options]="countyOptions" optionLabel="label" optionValue="value"
        formControlName="county" placeholder="Select county" [readonly]="true" />
      @if (errorFor('county', { required: 'County is required.' }); as msg) {
      <span class="error-text">{{ msg }}</span>
      }
    </div>
    <div class="field mobile-top">
      <label class="field-label" for="state">State<span class="required">*</span></label>
      <p-select inputId="state" styleClass="w-full" [options]="stateOptions" optionLabel="label" optionValue="value"
        formControlName="state" placeholder="Select state" [readonly]="true" />
      @if (errorFor('state', { required: 'State is required.' }); as msg) {
      <span class="error-text">{{ msg }}</span>
      }
    </div>
  </div>

  <div class="field-row owner-timeline-row">
    <div class="field owner-field mobile-top">
      <label class="field-label">Are you the Property Owner?<span class="required">*</span></label>
      <div class="radio-group">
        <div class="radio-option">
          <p-radioButton inputId="isOwner-yes" name="isOwner" value="yes" formControlName="isOwner" />
          <label for="isOwner-yes">Yes</label>
        </div>
        <div class="radio-option">
          <p-radioButton inputId="isOwner-no" name="isOwner" value="no" formControlName="isOwner" />
          <label for="isOwner-no">No</label>
        </div>
      </div>
    </div>
    <div class="field timeline-field mobile-top">
      <label class="field-label">When do you plan on starting to build ADU?<span class="required">*</span></label>
      <div class="radio-group">
        @for (option of buildTimelineOptions(); track option.value) {
        <div class="radio-option">
          <p-radioButton [inputId]="'buildTimeline-' + option.value" name="buildTimeline" [value]="option.value"
            formControlName="buildTimeline" />
          <label [for]="'buildTimeline-' + option.value">{{ option.label }}</label>
        </div>
        }
      </div>
    </div>
  </div>
</div>
